<template>
    <div class="loading-indicator vld-parent">
        <loading :active.sync="isLoadingData"
                 :is-full-page="true"
                 :height="height"
                 :width="width"
                 :color="color"
                 :loader="loader"
                 :background-color="bgColor"
        ></loading>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: 'checkout-errors',

        props: [
            'errors'
        ],

        components: {
            Loading
        },

        data() {
            return {
                fullPage: true,
                canCancel: false,
                useSlot: false,
                loader: 'spinner',
                color: '#4f9e9c',
                bgColor: '#ffffff',
                height: 64,
                width: 64,
                timeout: 3000, //ms
            }
        },

        computed: {
            ...mapGetters('app', [
                'isLoadingData',
            ]),

        }
    }
</script>
